import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { ConfirmDialog } from 'primereact/confirmdialog';
import "primereact/resources/primereact.min.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { Dropdown } from 'primereact/dropdown';
import { BiPlusMedical } from 'react-icons/bi';
import { Api } from '../../services/api';
import { InputNumber } from 'primereact/inputnumber';
import './LabourFramingCalculator.css'
import { MultiSelect } from 'primereact/multiselect';
import { FaTrash } from 'react-icons/fa';

const LabourFramingCalculator = () => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [projectType, setProjectType] = useState([]);
    const [LabourFramingList, setLabourFramingList] = useState([]);
    const [searchProjectType, setSearchProjectType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState('');

    const toast = useRef(null);
    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);

    // -------------------------------------------------------------
    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    // -------------------------------------------------------------
    const [projectList, setProjectList] = useState([]);
    const [hourlyRateList, setHourlyRateList] = useState([]);

    // -------------------------------------------------------------

    const formik = useFormik({
        initialValues: {
            projectId: '',
            hourly_rate: [], // Ensure this is an array
            crew_rate: 0,
            duration_days: 0,
            cost_estimate: 0,
            budget: 0,
            start_date: '',
            end_date: '',
                        
            userId: '',
        },

        validate: (data) => {
            let errors = {};

            if (!data.projectId) {
                errors.projectId = 'Please Select a Project.';
            }
            return errors;
        },

        onSubmit: (data) => {
            const userId = localStorage.getItem('user_id');

            const costEstimate = parseFloat(data.crew_rate) * parseInt(data.duration_days);

            const payload = {
                ...data,
                userId: userId ,
                cost_estimate: costEstimate
            };
            var url = Api.API_BASE_URL + 'labour-framing/save';

            const token = localStorage.getItem('authToken');
            const headers = {
                'Authorization': token ? `Bearer ${token}` : '',
                "Content-Type": "application/json",
            };  

            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(payload),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                        getProjectType()
                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        closeModal();
                        getProjectType();
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });

            console.log(data);
        }
    });
    // -------------------------------------------------------------


    const [pageNumber, setPageNumber] = useState(0);
    const projectsPerPage = 5;
    const pagesVisited = pageNumber * projectsPerPage;


    const [type, setType] = useState('Add');
    const [title, setTitle] = useState('Add Project Type');
    const [projectTypeID, setProjectTypeID] = useState();
    const [selectedProduct, setSelectedProduct] = useState(null);


    const openModal = () => {
        setProjectTypeID('');
        formik.resetForm();
        setType('Add');
        setTitle('Add Project Type');
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsDeleteConfirmationModalOpen(false);
    };



    // const editModal = (row) => {
    //     setProjectTypeID(row.Qbid);
    //     formik.setFieldValue('budget', row.budget);
    //     formik.setFieldValue('projectId', row.projectId);
    //     formik.setFieldValue('hourly_rate', row.hourly_rate);
    //     formik.setFieldValue('duration_days', row.duration_days);
    //     formik.setFieldValue('start_date', row.start_date);
    //     formik.setFieldValue('end_date', row.end_date);
    //     formik.setFieldValue('crew_rate', row.crew_rate);

    //     setType('Edit');
    //     setTitle('Edit Project Type');
    //     setIsModalOpen(true);
    // };

    const editModal = (row) => {
        setProjectTypeID(row._id);
        formik.setFieldValue('budget', row.budget);
        formik.setFieldValue('projectId', row.projectId);
        formik.setFieldValue('hourly_rate', Array.isArray(row.hourly_rate) ? row.hourly_rate : [row.hourly_rate]); // Ensure it's an array
        formik.setFieldValue('duration_days', row.duration_days);
        formik.setFieldValue('cost_estimate', row.cost_estimate);
        formik.setFieldValue('start_date', row.start_date);
        formik.setFieldValue('end_date', row.end_date);
        formik.setFieldValue('crew_rate', row.crew_rate);
    
        setType('Edit');
        setTitle('Edit Project Type');
        setIsModalOpen(true);
    };    


    useEffect(() => {
        console.log('Fetching projects...xx');
        getProjectType();

    }, []);

    useEffect(() => {

    }, []);

    const getProjectType = () => {
        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };  

        axios.get(Api.API_BASE_URL + 'labour-framing',  { headers:headers })
            .then((response) => {
                const data = response.data.projectList; 
                
                const hourlyRates = response.data.hourly_rate; // Get hourly_rate
                
                // const LabourFramingList = response.data.LabourFramingList; // Get hourly_rate

                const LabourFramingList = response.data.LabourFramingList.map(item => ({
                    ...item,
                    hourly_rate: item.hourly_rate ? item.hourly_rate.split(',') : [], // Transform string to array if needed
                }));                    

                setProjectList(data);
                setHourlyRateList(hourlyRates); // Set hourly_rate
                setLabourFramingList(LabourFramingList); // Set hourly_rate
                console.log('Fetched projectList:', data);
                console.log('Fetched hourly rates:', hourlyRates);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setIsLoading(false);
            });

    };


    
    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <div onClick={(e) => e.stopPropagation()}>
                   
                    <FaTrash onClick={() => handleDeleteProject(rowData.id)} style={{ color: 'darkred' }} />
                </div>
            </React.Fragment>
        );
    };

    const handleDeleteProject = (projectId,) => {
        setProjectTypeID(projectId);
        setIsDeleteConfirmationModalOpen(true);
    };


    const confirmDelete = async () => {
        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };  
        axios.get(Api.API_BASE_URL + 'labour-framing/delete/' + projectTypeID, { headers })
            .then((response) => {
                toast.current.show({ severity: 'info', summary: 'Confirmed', detail: response.data.result, life: 3000 });
                getProjectType();
                closeModal();
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });
    }

    const searchrole = (searchValue) => {
        console.log('searchValue', searchValue);

        setProjectType([]);
        const searchResult = searchProjectType.filter((item) =>
            item.QbProjectName.toLowerCase().includes(searchValue.toLowerCase())
        );
        setProjectType(searchResult);
        console.log(searchResult)
    }

    const header = (
        <div className="flex flex-wrap  align-items-center justify-content-between m-2 ">
            <h4 > </h4>
            <div>
                <span className="p-input-icon-left ">
                    <InputText className="input-field" type="search" onChange={(e) => searchrole(e.target.value)} placeholder="Search..." />
                </span>
                <button type="button" title='Add a new project' style={{ cursor: 'pointer' }} onClick={openModal} className="custom-button m-2" >
                    <div className='flex gap-2 px-1 py-1' style={{ alignItems: 'center' }}>
                        <BiPlusMedical size={14} />
                        <span> ADD </span>
                    </div>
                </button>
            </div>
        </div>
    );

    const onRowSelect = (e) => {
        const rowData = e.data;
        console.log("Row Data:", e.data);
        editModal(rowData);
    };

    const formatCurrency = (value) => {
        if (value == null) return '';
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD', 
        }).format(value);
    };

    const formatPercentage = (value) => {
        if (value == null) return '';
        return new Intl.NumberFormat('en-US', {
            style: 'percent',
            minimumFractionDigits: 2, // Adjust this for the number of decimal places you want
            maximumFractionDigits: 2,
        }).format(value);
    };

    return (
        <>

            <div className="pagee-container mt-2">
                <Toast ref={toast} />
                <ConfirmDialog />
                <div className="pagination-datable-height">
                    {isLoading ? (
                        <div className="loading-spinner">
                            Loading...
                            <div className="spinner"></div>
                        </div>
                    ) : (

                        <DataTable
                            value={LabourFramingList}
                            paginator
                            rows={14}
                            key="id"
                            tableStyle={{ minWidth: '50rem', }}
                            selectionMode="single"
                            selection={selectedProduct}
                            onRowSelect={onRowSelect}
                            onSelectionChange={(e) => setSelectedProduct(e.value)}
                            header={header}
                            globalFilter={globalFilter}
                            scrollHeight="flex"
                        >
                            <Column key="action" body={actionBodyTemplate} header="Action" exportable={false} style={{ width: '100px', alignItems: 'center', textAlign: 'center' }} />

                            <Column field="project_name" header="Address" style={{ width: '250px', paddingLeft: '5px' }} />
                            <Column field="project_type" header="Building Type" style={{ width: '200px', textAlign: 'center' }} />
                            <Column field="sq_feet_total" header="Sq/ft Total" style={{ width: '100x', textAlign: 'center' }} />
                            <Column field="hourly_rate" header="Hourly rate" style={{ width: '100px', textAlign: 'center' }} />
                            <Column field="crew_rate" header="Crew Rate" body={(rowData) => formatCurrency(rowData.crew_rate)} style={{ width: '100px', textAlign: 'center' }} />
                            {/* <Column field="start_date" header="Start Date" style={{ width: '110px', textAlign: 'center' }} /> */}
                            {/* <Column field="end_date" header="End Date" style={{ width: '100px', textAlign: 'center' }} /> */}
                            <Column field="duration_days" header="Duration Days" style={{ width: '80px', textAlign: 'center' }} />
                            <Column field="cost_estimate" header="Cost Estimate" body={(rowData) => formatCurrency(rowData.cost_estimate)} style={{ width: '100px', textAlign: 'center' }} />
                            <Column field="cost_per_sf" header="Cost per Sq/ft" body={(rowData) => formatCurrency(rowData.cost_per_sf)} style={{ width: '120px', textAlign: 'center' }} />
                            <Column field="budget" header="Budget" body={(rowData) => formatCurrency(rowData.budget)} style={{ width: '100px', textAlign: 'center' }} />
                            {/* <Column field="difference" header="Diffrence" body={(rowData) => formatCurrency(rowData.difference)} style={{ width: '100px', textAlign: 'center' }} /> */}
                            <Column field="difference" header="Diffrence"
                                body={(rowData) => (
                                    <span className={rowData.difference < 0 ? 'labour-framing-calculator-positive' : 'labour-framing-calculator-negative'}>
                                        {formatCurrency(rowData.difference)}
                                    </span>
                                )}
                                style={{ width: '100px', textAlign: 'center' }} />
                            <Column field="average_for_building_type" body={(rowData) => formatCurrency(rowData.average_for_building_type)} header="Avarage for building type" style={{ textAlign: 'center' }} />

                        </DataTable>
                    )}
                </div>
            </div>
            
            {/* ---------------------------------------------------------------*/}
            <Dialog 
            header="Labour Framing Calculator" 
            visible={isModalOpen} 
            maximizable 
            className="custom-dialog" 
            style={{ width: '50vw', height: '400px' }} // Let height adjust to content
            contentStyle={{ overflowY: 'hidden' }} // Disable vertical scroll
            dismissableMask="true" 
            onHide={() => { setIsModalOpen(false); setSelectedProduct(null); }}
            >
                <div className='card'>
                    <form onSubmit={formik.handleSubmit} className="labour-framing-calculator-form" >
                        <div className=" flex">

                            <div className="col-6 ">
                                <label className='card-heading'>Address</label>
                                <Dropdown
                                    optionValue='_id'
                                    id="projectId"
                                    name="projectId"
                                    placeholder="Select a Project"
                                    options={projectList}
                                    optionLabel="project_name"
                                    value={formik.values.projectId}
                                    filter
                                    onChange={(e) => {
                                        console.log(e.value);
                                        formik.setFieldValue('projectId', e.value);
                                    }}
                                    className={classNames('p-2 sxsx', { 'p-invalid': isFormFieldInvalid('projectId') })} style={{ width: '100%', }}
                                />
                            </div>

                            <div className="col-6">
                                <label className='card-heading'>Hourly rate</label>

                                <MultiSelect
                                    id="hourly_rate"
                                    name="hourly_rate"
                                    placeholder="Select a Role"
                                    options={hourlyRateList}
                                    optionLabel="name"
                                    optionValue="name"

                                    value={formik.values.hourly_rate.length ? formik.values.hourly_rate : []}
                                    // value={Array.isArray(formik.initialValues.hourly_rate) ? formik.initialValues.hourly_rate : []}

                                    onChange={(e) => {

                                        formik.setFieldValue('hourly_rate', e.value);
                                        const selectedOptions = e.value;

                                        // Calculate the sum of the selected billableRates
                                        const sumOfBillableRates = selectedOptions.reduce((sum, rate) => {
                                            const selectedRate = hourlyRateList.find(item => item.name === rate);
                                            return sum + (selectedRate ? Number(selectedRate.billableRate) : 0);
                                        }, 0);

                                        console.log('sumOfBillableRates-------->', sumOfBillableRates)

                                        // updateBudget();
                                        formik.setFieldValue('crew_rate', sumOfBillableRates)

                                    }}
                                    className={classNames('p-2',)} style={{ width: '100%' }}
                                />

                            </div>

                        </div>
                        <div className=" flex">

                            <div className="col-3 ">
                                <label className='card-heading' >Crew Rate</label>

                                <InputNumber
                                    inputId="crew_rate"
                                    value={formik.values.crew_rate}
                                    className="text-center"
                                    inputClassName={formik.values.crew_rate < 0 ? "is-negative" : "is-positive"}
                                    placeholder="$0.00"
                                    // onChange={(e) => {
                                    //     formik.setFieldValue('crew_rate', e.value);
                                    // }}
                                    // onChange={handleDurationDaysChange} 
                                    mode="currency"
                                    currency="USD"
                                    locale="en-US"
                                    disabled
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        boxSizing: "border-box",
                                        border: "none",
                                        fontSize: "16px",
                                        textAlign: "center",
                                        marginTop: "0px",
                                        outline: 'none',
                                    }}
                                />
                            </div>
                            <div className="col-3 ">
                                <label className='card-heading'>Duration Days</label>
                                <InputText
                                    type='number'
                                    id="duration_days"
                                    name="duration_days"
                                    value={parseInt(formik.values.duration_days)}
                                   
                                    onChange={(e) => {
                                        const newDurationDays = e.target.value; // Get the new value
                                        formik.setFieldValue('duration_days', newDurationDays); // Update formik state
                                        // updateBudget();
                                    }}
                                    className={classNames('p-2', { 'p-invalid': isFormFieldInvalid('duration_days') })} style={{ width: '100%' }}
                                />
                            </div>

                            <div className="col-3 ">
                                <label className='card-heading'>Cost Estimate</label>

                                <InputNumber
                                    inputId="cost_estimate"
                                    // value={formik.values.budget}
                                    value={parseFloat(formik.values.crew_rate) * parseInt(formik.values.duration_days) * 8}
                                    className="text-center"
                                    inputClassName={formik.values.budget < 0 ? "is-negative" : "is-positive"}
                                    placeholder="$0.00"
                                    mode="currency"
                                    currency="USD"
                                    locale="en-US"
                                    disabled
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        boxSizing: "border-box",
                                        border: "none",
                                        fontSize: "16px",
                                        textAlign: "center",
                                        marginTop: "0px",
                                        outline: 'none',
                                    }}
                                />
                            </div>

                            <div className="col-3 ">
                                <label className='card-heading'>Budget</label>

                                <InputNumber
                                    inputId="budget"
                                    value={formik.values.budget}
                                    className="text-center"
                                    inputClassName={formik.values.budget < 0 ? "is-negative" : "is-positive"}
                                    placeholder="$0.00"
                                    onChange={(e) => {
                                        formik.setFieldValue('budget', e.value);
                                    }}
                                    mode="currency"
                                    currency="USD"
                                    locale="en-US"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        boxSizing: "border-box",
                                        border: "none",
                                        fontSize: "16px",
                                        textAlign: "center",
                                        marginTop: "0px",
                                        outline: 'none',
                                    }}
                                />
                            </div>

                        </div>
                        <div className="flex flex-wrap justify-content-center mt-5">
                            <Button label="Submit" type="submit" className=' customSave-button' />
                        </div>
                    </form>
                </div>
            </Dialog>

            {/* ---------------------------------------------------------------*/}

            {isDeleteConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Delete Confirmation</h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>"Are you sure you want to delete this project? "</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="delete-buttonx" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default LabourFramingCalculator